import React from 'react';
import PropTypes from 'prop-types';
import { TypeRankingsEntities } from 'client/data/models/type-rankings-entities';
import { getAnchorName, hasSubsegments } from 'site-modules/shared/utils/upper-funnel/type-rankings';
import { AnchorNavSticky } from 'site-modules/shared/components/anchor-nav-sticky/anchor-nav-sticky';

export function AnchorNav({
  vehicleEditorialRankings,
  isMobile,
  mostSoldTypeGraphTitle,
  type,
  navSuvList,
  title,
  className,
  titleClassName,
  subLinkClassName,
  subArrowClassName,
  containerClassName,
  ariaLabel,
  noScroll,
  hasSeparator,
  hideSticky,
  useItemClassName,
  useNoFollow,
}) {
  const withSubsegments = hasSubsegments(vehicleEditorialRankings);

  if (!withSubsegments && !mostSoldTypeGraphTitle && !navSuvList) {
    return null;
  }

  let navList = [];

  if (withSubsegments) {
    navList = vehicleEditorialRankings.map(({ displayName }) => ({
      name: displayName,
      hash: `${getAnchorName(displayName)}`,
    }));
  }

  if (mostSoldTypeGraphTitle) {
    navList.push({
      name: mostSoldTypeGraphTitle,
      hash: `best-selling-${type}s`,
    });
  }

  if (navSuvList) {
    navList = navSuvList.map(({ name, hash }) => ({
      name,
      hash,
    }));
  }

  return (
    <AnchorNavSticky
      className={className}
      titleClassName={titleClassName}
      subLinkClassName={subLinkClassName}
      subArrowClassName={subArrowClassName}
      navList={navList}
      isMobile={isMobile}
      title={title}
      ariaLabel={ariaLabel}
      noScroll={noScroll}
      hasSeparator={hasSeparator}
      hideSticky={hideSticky}
      containerClassName={containerClassName}
      useItemClassName={useItemClassName}
      useNoFollow={useNoFollow}
    />
  );
}

AnchorNav.propTypes = {
  vehicleEditorialRankings: PropTypes.arrayOf(PropTypes.shape(TypeRankingsEntities.VehicleRankingDescription)),
  navSuvList: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      hash: PropTypes.string,
    })
  ),
  isMobile: PropTypes.bool,
  mostSoldTypeGraphTitle: PropTypes.string,
  type: PropTypes.string.isRequired,
  titleClassName: PropTypes.string,
  subLinkClassName: PropTypes.string,
  subArrowClassName: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string,
  ariaLabel: PropTypes.string,
  noScroll: PropTypes.bool,
  hasSeparator: PropTypes.bool,
  hideSticky: PropTypes.bool,
  containerClassName: PropTypes.string,
  useItemClassName: PropTypes.bool,
  useNoFollow: PropTypes.bool,
};

AnchorNav.defaultProps = {
  vehicleEditorialRankings: null,
  navSuvList: null,
  isMobile: false,
  mostSoldTypeGraphTitle: null,
  className: 'type-anchor-nav mb-1 mt-0',
  titleClassName: 'heading-5 pe-1 py-1',
  subLinkClassName: undefined,
  subArrowClassName: null,
  title: undefined,
  ariaLabel: undefined,
  noScroll: false,
  hasSeparator: true,
  hideSticky: false,
  containerClassName: 'container',
  useItemClassName: true,
  useNoFollow: true,
};
